import { useHotkeys } from 'react-hotkeys-hook';
import { useNavigate } from 'react-router-dom';
import type { HandleToggleChangeProps } from '../types/canvas.types';
interface UseAnalysisShortcutsProps {
  isPopupOpen: boolean;
  setIsPopupOpen: (isOpen: boolean) => void;
  handleToggleChange: HandleToggleChangeProps;
}

export const useAnalysisShortcuts = ({
  isPopupOpen,
  setIsPopupOpen,
  handleToggleChange,
}: UseAnalysisShortcutsProps) => {
  const navigate = useNavigate();

  useHotkeys('escape', () => {
    isPopupOpen ? setIsPopupOpen(!isPopupOpen) : handleToggleChange('preview');
  });

  useHotkeys('backspace', () => {
    !isPopupOpen && navigate('/');
  });
};
